module.exports = __webpack_public_path__ + "static/sidemail-public--homepage-cta-d851a2938353edc685e137b9acc2823d.webp";